import { FORM_INPUT } from "@/constants/DataTypes";
import {
  FORM_FIELD_DATA_TYPE_TEXT,
  FORM_FIELD_MENU_ITEMS,
  isFormFieldElementType,
  SEEDED_FORM_FIELD_CONTENT,
} from "@/constants/FormFieldConstants.mjs";

/**
 * The Add Element menu item that describes a form field element, for showing its icon and label
 * elsewhere. An `input` resolves by `content.multiLine`, then `content.dataType`.
 * @param {import("immutable").Map<string, any>} element
 * @returns {import("@/constants/FormFieldConstants.mjs").FormFieldMenuItem | undefined} `undefined` when the element is not a form field.
 */
export const getFormFieldMenuItem = (element) => {
  const type = element.get("type");

  if (!isFormFieldElementType(type)) return undefined;

  if (type !== FORM_INPUT) return FORM_FIELD_MENU_ITEMS.find(({ field }) => field.type === type);// handles select, checkbox, radio because for input there are multiple

  if (element.getIn(["content", "multiLine"])) {
    return FORM_FIELD_MENU_ITEMS.find(({ field }) => field.multiLine);
  }

  const dataType = element.getIn(["content", "dataType"]) ?? FORM_FIELD_DATA_TYPE_TEXT;
  return FORM_FIELD_MENU_ITEMS.find(
    ({ field }) => field.type === FORM_INPUT && !field.multiLine && field.dataType === dataType,
  );
};

/**
 * The name a form field goes by in the Layers panel: its `content.label`, else its field type
 * (e.g. "Dropdown") when the label is blank or still the type's seeded default ("Label").
 * @param {import("immutable").Map<string, any>} element
 * @returns {string | undefined} `undefined` when the element is not a form field.
 */
export const getFormFieldDisplayName = (element) => {
  const menuItem = getFormFieldMenuItem(element);

  if (!menuItem) return undefined;

  const label = element.getIn(["content", "label"])?.trim();
  const seededLabel = SEEDED_FORM_FIELD_CONTENT[element.get("type")]?.label;

  return label && label !== seededLabel ? label : menuItem.label;
};
